// @ts-nocheck
import { createSignal, Show, For } from "solid-js";
import { useAdminContext } from "./AdminContext";

export default (props) => {
  const [adminStore, setAdminStore, { editUser, deleteUser, addUser }] = useAdminContext();
  const [showAddModal, setShowAddModal] = createSignal(false);
  const [newUsername, setNewUsername] = createSignal('');
  const [newEmail, setNewEmail] = createSignal('');
  const [newRole, setNewRole] = createSignal('student');

  const handleAddUser = (e) => {
    e.preventDefault();
    const username = newUsername().trim();
    if (!username) return;
    addUser({
      username,
      email: newEmail().trim() || null,
      role: newRole()
    });
    setNewUsername('');
    setNewEmail('');
    setNewRole('student');
    setShowAddModal(false);
  };

  return (
    <div class="card-panel">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-4 pb-2 border-bottom gap-2">
        <div>
          <h2 class="h4 fw-bold text-dark mb-1">Gestion des utilisateurs</h2>
          <p class="text-muted small mb-0">Administrez les comptes utilisateurs, leurs rôles et leurs adresses de notification.</p>
        </div>
        <button
          type="button"
          class="btn btn-primary d-inline-flex align-items-center gap-2 shadow-sm"
          onClick={() => setShowAddModal(true)}
        >
          <i class="bi bi-person-plus-fill"></i>
          <span>Ajouter un utilisateur</span>
        </button>
      </div>

      <Show when={showAddModal()}>
        <div class="modal show d-block" style="background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(4px);" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content shadow-lg border-0 rounded-4">
              <form onSubmit={handleAddUser}>
                <div class="modal-header border-bottom-0 pb-0">
                  <h5 class="modal-title fw-bold">Créer un utilisateur</h5>
                  <button type="button" class="btn-close" onClick={() => setShowAddModal(false)}></button>
                </div>
                <div class="modal-body py-4">
                  <div class="mb-3">
                    <label class="form-label fw-semibold">Identifiant / Username <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Ex: jdupont"
                      required
                      autofocus
                      value={newUsername()}
                      onInput={(e) => setNewUsername(e.currentTarget.value)}
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label fw-semibold">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Ex: jean.dupont@unistra.fr"
                      value={newEmail()}
                      onInput={(e) => setNewEmail(e.currentTarget.value)}
                    />
                  </div>
                  <div class="mb-2">
                    <label class="form-label fw-semibold">Rôle</label>
                    <select
                      class="form-select"
                      value={newRole()}
                      onChange={(e) => setNewRole(e.currentTarget.value)}
                    >
                      <option value="student">Étudiant (student)</option>
                      <option value="teacher">Évaluateur / Enseignant (teacher)</option>
                      <option value="admin">Administrateur (admin)</option>
                    </select>
                  </div>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                  <button type="button" class="btn btn-light" onClick={() => setShowAddModal(false)}>Annuler</button>
                  <button type="submit" class="btn btn-primary" disabled={!newUsername().trim()}>Créer l'utilisateur</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Show>

      <div class="table-responsive border rounded-3">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th style="width: 70px;">ID</th>
              <th>Utilisateur</th>
              <th>Email</th>
              <th>Rôle</th>
              <th class="text-end" style="width: 160px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <For each={adminStore.users}>
              {(user, index) => (
                <tr>
                  <td class="text-muted small font-monospace">#{user.id}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span
                        class={user.connected ? 'connected-badge' : 'disconnected-badge'}
                        title={user.connected ? 'En ligne' : 'Hors ligne'}
                      ></span>
                      <span class="fw-semibold text-dark">{user.username}</span>
                    </div>
                  </td>
                  <td>
                    <Show
                      when={user.editing}
                      fallback={user.email ? <span class="text-muted">{user.email}</span> : <span class="text-muted fst-italic">Non renseigné</span>}
                    >
                      <input
                        class="form-control form-control-sm"
                        value={user.emailInput || ''}
                        placeholder="email@unistra.fr"
                        onInput={(e) => setAdminStore('users', index(), { emailInput: e.currentTarget.value })}
                      />
                    </Show>
                  </td>
                  <td>
                    <Show
                      when={user.editing}
                      fallback={
                        <span class={`badge rounded-pill ${user.role === 'admin' ? 'bg-danger-subtle text-danger border border-danger-subtle' : 'bg-primary-subtle text-primary border border-primary-subtle'}`}>
                          {user.role}
                        </span>
                      }
                    >
                      <select
                        class="form-select form-select-sm"
                        value={user.roleInput || user.role}
                        onChange={(e) => setAdminStore('users', index(), { roleInput: e.currentTarget.value })}
                      >
                        <option value="student">student</option>
                        <option value="teacher">teacher</option>
                        <option value="admin">admin</option>
                      </select>
                    </Show>
                  </td>
                  <td class="text-end">
                    <Show when={user.editing}>
                      <button
                        type="button"
                        class="btn btn-sm btn-success me-1"
                        onClick={() => editUser(index())}
                        title="Enregistrer"
                      >
                        <i class="bi bi-check-lg"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-light"
                        onClick={() => setAdminStore('users', index(), { editing: false })}
                        title="Annuler"
                      >
                        <i class="bi bi-x-lg"></i>
                      </button>
                    </Show>
                    <Show when={!user.editing}>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary me-1"
                        onClick={() => setAdminStore('users', index(), {
                          editing: true,
                          roleInput: user.role,
                          emailInput: user.email || '',
                        })}
                        title="Modifier"
                      >
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        onClick={() => {
                          if (confirm(`Confirmez-vous la suppression de l'utilisateur ${user.username} ?`)) {
                            deleteUser(user.id);
                          }
                        }}
                        title="Supprimer"
                      >
                        <i class="bi bi-trash"></i>
                      </button>
                    </Show>
                  </td>
                </tr>
              )}
            </For>
          </tbody>
        </table>
      </div>
    </div>
  );
};